import { DualDatePicker } from '../../../Components/Index';

const toEnglishDigits = value => String(value ?? '')
  .replace(/[۰-۹]/g, digit => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))
  .replace(/[٠-٩]/g, digit => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit))
  .replace(/[^\d]/g, '');

const formatMileage = value => {
  const digits = toEnglishDigits(value);
  return digits ? Number(digits).toLocaleString('fa-IR') : '';
};

export default function ServiceDetailsForm({ currentMileage, serviceDate, onCurrentMileage, onDate }) {
  return <section className="service-one-card service-one-details">
    <div className="service-one-details__fields">
      <label>کیلومتر سرویس<input aria-label="کیلومتر سرویس" inputMode="numeric" value={formatMileage(currentMileage)} onChange={event => onCurrentMileage(toEnglishDigits(event.target.value))} placeholder="مثال: ۵۰٬۰۰۰" /></label>
      <DualDatePicker shamsiOnly value={serviceDate} onChange={onDate} label="تاریخ سرویس (شمسی)" placeholder="انتخاب تاریخ شمسی" />
    </div>
  </section>;
}
